import React, { useMemo, useRef } from "react";
import "../../../Assets/Css/Invoice.scss";
import Table from "../../../Components/Table";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Invoicefilter from "../../../Components/Invoice-filter";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { deletePurchaseInvoices, getCurrencyList, getInvoices, getPurchaseInvoices, getSystemSettings, importPurchaseInvoiceCSV } from "../../../Services/Invoices/action";
import qs from "query-string";
import { api } from "../../../Lib/constants";
import { getAuthHeader } from "../../../Lib/utils";
import { toast, ToastContainer } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import { getClients } from '../../../Services/Clients/action'
import { DefaultCurrencykey } from "../../../Lib/constants";

const Purchaseinvoices = (props) => {
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [selectedId, setSelectedId] = useState([]);
  const [params, setParams] = useState({});
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportrLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inData, setInData] = useState([]);
  const [isDeleted, setIsDeleted] = useState(false);
  const [currencyData, setCurrencyData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);
  const modalRef = useRef(null);

  const navigate = useNavigate();

  const header = [
    { field: "checkbox" },
    { field: "Seller" },
    { field: "Item-Name" },
    { field: "Date" },
    { field: "Invoice-Total" },
    { field: "Gst" },
    { field: "Share Holders" },
    { field: "Action" },
  ];

  let footer = true;
  let count = props?.purchaseInvoice?.length;

  // TODO: try with async flow
  useEffect(() => {
    setIsLoading(true)
    props?.getCurrencyList();
    props.getPurchaseInvoices();
    props.getSystemSettings();
    props.getClientsList();
    fetchData();
    setIsLoading(false)
  }, [location.search]);

  useEffect(() => {
    fetchCurrencyData();
  }, []);

  useEffect(() => {
    setTheCurrencyData()
  }, [props?.currencylist])

  const fetchCurrencyData = async () => {
    try {
      await props.getCurrencyList();
      setTheCurrencyData();
    } catch (error) {
    }
  }

  const setTheCurrencyData = async () => {
    try {
      setCurrencyData(await props?.currencylist);
    } catch (error) {
      toast.error(error);
    }
  }

  const fetchData = async () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      await props.getInvoicesList(location.search);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const showToastMessage = (error) => {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  useEffect(() => {
    props?.purchaseInvoice
      ? setInData(
        props?.purchaseInvoice?.map((purchaseinvoice) => {
          // const shareHolder = new Set();
          // invoice?.invoiceTransactionMap?.map((invoiceTransaction) => {
          //   invoiceTransaction?.transactionInvoiceMap?.transactionShareHolderMap?.map(
          //     (tranShalehoder) => {
          //       shareHolder.add(
          //         tranShalehoder?.shareHolderTransactionMap?.name
          //       );
          //     }
          //   );
          // });

          const DefaultCurrencyCode = props?.systemsettings?.find((item) => item?.key === DefaultCurrencykey)?.value;

          const DefaultCurrencySymbol = props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;

          // const currencycode = props?.currencylist?.find((item) => item.id === invoice?.currency_id)?.code

          // const filtercurrencycode = (currencycode === DefaultCurrencyCode ?
          //   "-" :
          //   `${invoice.total || 0} (${currencycode || "-"})`);


          return {
            checkbox: {
              value: purchaseinvoice?.id,
              type: "checkbox",
            },
            Seller: {
              value: purchaseinvoice?.seller_name,
              type: "client",
            },
            "Item-Name": {
              value: purchaseinvoice?.item_name,
              type: "text",
            },
            Date: {
              value: purchaseinvoice?.purchase_date.split(" ")[0],
              type: "date",
            },
            "Invoice-Total": {
              value: `${DefaultCurrencySymbol}${purchaseinvoice?.invoice_total}`,
              type: "amount",
            },
            "Gst": {
              value: `${DefaultCurrencySymbol}${purchaseinvoice?.gst_amount}`,
              type: "amount",
            },
            "Share Holders": {
              // value:shareHolder.toString(),
              value: purchaseinvoice?.purchaseinvShareholderMap?.map((shareHolder) => {
                const shId = shareHolder?.shareholder_id;
                const shName = props?.shareHolderDetails?.shareholderslist?.filter((f) => shId === f?.id)?.map((item) => item?.name)
                let value = {
                  name: shName?.join(", "),
                };
                if (shareHolder?.src) {
                  value = {
                    ...value,
                    src: shareHolder?.src,
                  };
                }
                return value;
              }),
              // value: Array.from(shareHolder).map((item) => ({ name: item })),
              type: "share holder",
            },
            Action: {
              value: "/purchaseinvoices/edit",
              value2: "/purchaseinvoices/view",
              type: "action",
            },
            invoiceId: {
              value: purchaseinvoice.id,
            },
          };
        })
      )
      : setInData([]);
  }, [props?.purchaseInvoice, props?.systemsettings, props?.currencylist]);

  const handleClose = () => {
    setShowModal(false);
    setFileName('');
    setSelectedFile(null);
    fileInputRef.current.value = null;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
        setFileName('');
        setSelectedFile(null);
        fileInputRef.current.value = null;

      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClose]);

  const handleFileChange = (event) => {
    const f = event.target.files[0];
    setSelectedFile(f);
    if (f) {
      setFileName(f.name);
    } else {
      setFileName('');
    }
  }


  const handleImportClick = async (event) => {
    try {
      setLoading(true);

      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvData = e.target.result;
          await props.importPurchaseInvoiceCSV(selectedFile, csvData);
          setLoading(false);
          setFileName('');
          setSelectedFile(null);
          fileInputRef.current.value = null;
        } catch (error) {
          setHasError(true);
          console.error('Error importing purchse invoices:', error);
          toast.error('Error importing purchse invoices:', error.message);
          setLoading(false)

        }
      };

      reader.readAsText(selectedFile);

    } catch (error) {
      setHasError(true);
      console.error('Error importing transactions:', error);
      toast.error('Error importing transactions:', error.message);
      setLoading(false)
    }
  };

  const handleChange = (e) => {
    if (e[1] == "headerAll" && e[0] === true) {
      setTotalSelectedIds([...e[2]]);
    } else if (e[0] === true && e[1] !== "headerAll") {
      setTotalSelectedIds([...totalSelectedIds, e[1]]);
    } else if (e[1] == "headerAll" && e[0] === false) {
      setTotalSelectedIds([]);
    } else {
      let filterdId = totalSelectedIds.filter((item) => {
        return item != e[1];
      });
      setTotalSelectedIds(filterdId);
    }
  };

  // When Click on Delete or Export Button
  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));

    try {
      // Deletion Function 
      if (type === "delete") {
        setDeleteLoading(true);
        // Wait for the deletion to complete before moving on
        await props.deletePurchaseInvoices(ids);
        setChecked(false);
        setTotalSelectedIds([]);
      } else if (type === "export") {
        setExportrLoading(true);
        await handlePdfDownload(ids);
        toast.success("Exported Successfully");
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
      // if (!props.loading && props.success) {
      // }
      setDeleteLoading(false);
    }
  };

  // Pdf downloading API Calling
  const handlePdfDownload = async (ids) => {
    try {
      for (let id of ids) {
        let result = await api(
          `invoices/generate/pdf`,
          "post",
          { ids: [id] },
          getAuthHeader(),
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(result.data);
        downloadURI(url, `${id}.pdf`);
      }
      setExportrLoading(false);
    } catch (error) {
      let errorMessage = error?.message;
      showToastMessage(errorMessage);
      setExportrLoading(false);
    }
  };

  function downloadURI(uri, name) {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (totalSelectedIds.length > 0) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [totalSelectedIds]);

  const handleAddInvoice = () => {
    navigate("/purchaseinvoices/add")
  };

  return (
      <div className="invoice-main">
        <div className="page-title">
          <h4>Purchase Invoices</h4>
          <div className="edit-btn">
            <button type="button" disabled={props.loading} onClick={() => setShowModal(true)} className="custom-btn" style={{ position: 'relative', marginRight: "15px" }}>
              {props.loading ?
                <Spinner as="span" animation="border" className="custom-spinner" role="status" aria-hidden="true" />
                : <Link to='#' style={{ textDecoration: "inherit", color: "inherit" }}>Upload</Link>}
            </button>
            <button
              className="export-btn"
              id="exportBtn"
              disabled={!checked || exportLoading}
              onClick={(e) => {
                e.preventDefault();
                handleClick(totalSelectedIds, "export");
              }}
            >
              {exportLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  className="custom-spinner"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Export"
              )}
            </button>
            <button
              className="delete-btn"
              id="deleteBtn"
              disabled={!checked || deleteLoading}
              onClick={(e) => {
                e.preventDefault();
                handleClick(totalSelectedIds, "delete");
              }}
            >
              {deleteLoading ? (
                <Spinner
                  as="span"
                  animation="border"
                  className="custom-spinner"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Delete"
              )}
            </button>
            <button type="button" className="custom-btn" onClick={handleAddInvoice}>
              {props.loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  className="custom-spinner"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Add"
              )}
            </button>
          </div>
        </div>
        {showModal && (
          <div>
            <div className="modal show" tabIndex="-1" role="dialog" style={{ display: 'block', marginTop: '150px' }}>
              <div className="modal-dialog custom-modal-dialogue" role="document">
                <div className="modal-content" ref={modalRef}>

                  <div className="modal-header" style={{ display: 'flex' }}>
                    <h5 className="modal-title">Upload File</h5>

                  </div>
                  <div className="modal-body" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>

                      <input
                        type="file"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        ref={fileInputRef}
                      />
                      <Button onClick={() => fileInputRef.current.click()}>
                        Choose File
                      </Button>

                      <div style={{ marginLeft: '10px' }}>{fileName ? fileName : 'No File Selected'}</div>
                    </div>
                    {fileName ? <Button type="button" className="close" onClick={() => {
                      setSelectedFile(null);
                      setFileName('');
                      fileInputRef.current.value = null;

                    }} aria-label="Close" style={{ backgroundColor: 'gray', border: 'none' }}>
                      x
                    </Button> : ''}
                  </div>

                  <div className="modal-footer">
                    <Button variant="secondary" onClick={handleClose}>
                      cancel
                    </Button>
                    <Button
                      variant="primary"
                      onClick={handleImportClick}
                      disabled={loading || !selectedFile}
                    >
                      {loading ? <Spinner as="span" animation="border" className="custom-spinner" role="status" aria-hidden="true" /> : 'Proceed'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
        <div className="filter-part">
          <Invoicefilter filter={params} />
        </div>
        <div className="invoice-table-part">
          <Table
            header={header}
            data={inData}
            footer={footer}
            count={count}
            checked={checked}
            records={count}
            totalSelectedIds={totalSelectedIds}
            defaultParams={params}
            selectedId={selectedId}
            handleChange={handleChange}
            loading={props.loading}
          />
        </div>
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    invoices: state.invoicesReducer.invoices.rows,
    count: state.invoicesReducer.invoices.count,
    loading: state.invoicesReducer.loading,
    success: state.invoicesReducer.success,
    records: state.invoicesReducer.invoices.noOfRecords,
    currencylist: state.invoicesReducer.currencylist,
    systemsettings: state.invoicesReducer.systemsettings,
    purchaseInvoice: state.invoicesReducer.purchaseInvoice,
    shareHolderDetails: state.shareholdersReducer,

  };
};

export const mapDispatchToProps = {
  getInvoicesList: getInvoices,
  deletePurchaseInvoices: deletePurchaseInvoices,
  getCurrencyList: getCurrencyList,
  getSystemSettings: getSystemSettings,
  getClientsList: getClients,
  importPurchaseInvoiceCSV: importPurchaseInvoiceCSV,
  getPurchaseInvoices: getPurchaseInvoices,
};

export default connect(mapStateToProps, mapDispatchToProps)(Purchaseinvoices);
